import React, { Component } from 'react';
import queryString from 'query-string';
import { Form, Field } from 'react-final-form';
import Styles from "../Styles.js";
import { GlobalContext } from '../global-context.js';

export default class UserProvisionContainer extends Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            project: null
        };
    }

    componentDidMount() {
      const values = queryString.parse(this.props.location.search);
      const pid = values.project;
      const { devmode } = this.context;
      fetch(`/api/project/${pid}`)
        .then(res => res.json())
        .then(proj => {
          devmode && console.log("Project:", proj)
          this.setState({
            project: proj
          });
        });
    }

    onSubmit = async (values) => {
      const { setGlobalError } = this.context;
      let provisionObj
      if (values.ptype === "provision") {
        provisionObj = {
          provisioned: values.members
        }
      } else {
        provisionObj = {
          deprovisioned: values.members
        }
      }
      if (values.comment) {
        provisionObj.comment = values.comment
      }
      const endpoint = `/api/project/${this.state.project.id}/users/provision`;
      let res = await fetch(endpoint, {
        method: 'PUT',
        body: JSON.stringify(provisionObj),
        headers:{
            'Content-Type': 'application/json'
        }
      });
      if (!res || !res.ok) {
        let errdata = await res.json();
        const message = `error ${res.status} (de-)provisioning users: ${errdata.message}`;
        console.log(message);
        setGlobalError(message);
      }
      this.props.navigate(`project/${this.state.project.id}`);
    }

    render() {
        if (this.state.project == null) {
            return null
        }

        const { project } = this.state;
        const { config } = this.context;

        const provision = <table>
          <tbody>
            <tr key="headings">
              <td className="headings-row">Select</td>
              <td className="headings-row">Member</td>
              <td className="headings-row">State</td>
            </tr>
            {project.member_details.map((member, idx) => {
              let state = 0;
              if (member.state) {
                state = member.state;
              }
              let color = "#888"
              let greyed = true;
              if (state === 2) { // 2 -> MemberPending
                greyed = false;
                color = "#000"
              }
              return <tr key={idx}>
                <td>
                  {greyed || <Field
                      name="members"
                      value={member.eppn}
                      component="input"
                      type="checkbox"
                  />}
                </td>
                <td style={{color: color}}>{member.display_name}/{member.eppn}</td>
                <td style={{color: color}}>
                    {config.member_states[state]}
                </td>
              </tr>
            })}
          </tbody>
        </table>

        const deprovision = <table>
          <tbody>
            <tr key="headings">
              <td className="headings-row">Select</td>
              <td className="headings-row">Member</td>
              <td className="headings-row">State</td>
            </tr>
            {project.member_details.map((member, idx) => {
              let state = 0;
              if (member.state) {
                state = member.state;
              }
              let color = "#888"
              let greyed = true;
              if (state === 3) { // 3 -> MemberRemove
                greyed = false;
                color = "#000"
              }
              return <tr key={idx}>
                <td>
                  {greyed || <Field
                      name="members"
                      value={member.eppn}
                      component="input"
                      type="checkbox"
                  />}
                </td>
                <td style={{color: color}}>{member.display_name}/{member.eppn}</td>
                <td style={{color: color}}>
                    {config.member_states[state]}
                </td>
              </tr>})
            }
          </tbody>
        </table>

        const Condition = ({ when, is, whentrue, whenfalse }) => (
          <Field name={when} subscription={{ value: true }}>
            {({ input: { value } }) => (value === is ? whentrue : whenfalse)}
          </Field>
        )

        return (
          <div style={{padding: "20px"}}>
          <Styles>
            <h1>{project.title}</h1>
            <div>{project.description}</div>
            <h2>Sensitivity</h2>
            <table className="project-tags">
                <tbody>
                {
                    project.flags && project.flags.map((flag) =>
                    <tr key={flag.name}>
                        <td className="project-sensitivity">{flag.name}</td>
                    </tr>
                )}
                </tbody>
            </table>
            <Form
              onSubmit={this.onSubmit}
              initialValues={{ ptype: 'provision' }}
              render={({handleSubmit, form, submitting, pristine, values, invalid }) => (
                <form style={{width: "90%"}}
                  onSubmit={event => {
                    handleSubmit(event);
                  }}
                >
                  <h3>User Provisioning and De-provisioning</h3>
                  <Field
                    name="ptype"
                    component="input"
                    type="radio"
                    value="provision"
                  />Provision
                  <br/>
                  <Field
                    name="ptype"
                    component="input"
                    type="radio"
                    value="deprovision"
                  />De-provision
                  <Condition when="ptype" is="provision" whentrue={provision} whenfalse={deprovision} />
                  <Field
                    name="comment"
                    component="input"
                    type="text"
                    placeholder="(comment)"
                  />
                  <br />
                  <button type="submit" disabled={ invalid || submitting || pristine || values.members === undefined || (values.members && values.members.length === 0) }>
                    <Condition when="ptype" is="provision" whentrue="Mark provisioned" whenfalse="Mark de-provisioned" />
                  </button>
                </form>
              )}
            />
          </Styles>
        </div>
        );
    }
}
